import React from 'react';
import {FieldControl, GroupProps} from 'react-reactive-form';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

type SingleCheckboxControlProps = GroupProps & {
  label?: React.ReactNode;
  disabled?: boolean;
};

export const SingleCheckboxControl: React.FC<SingleCheckboxControlProps> = ({label, ...FieldControlProps}) => {
  return (
    <FieldControl
      {...FieldControlProps}
      render={({handler}) => {
        const {value, disabled, ...restHandlers} = handler();
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={!!value}
                {...restHandlers}
                disabled={disabled || FieldControlProps.disabled}
                color="primary"
              />
            }
            label={label}
          />
        );
      }}
    />
  );
};
